import { customColumnProps } from "@maherunlocker/custom-react-table";
import { t } from "i18next";
import React from "react";
import { CustomIcons } from "./CustomIcons";
import CustomColumnDisplay from "@components/Common/CustomColumnDisplay";
import PaymentMethodRow from "./PaymentMethodRow";
import { setItemsDisable } from "@store";
import { setGlobalDataIsUpdated, setIsLoading } from "../store";
import { ShowSuccessToast } from "@pages/SettingGeneral/Language/ShowSuccessToast";
import ErrorToast from "@components/Common/ErrorTost";
import { toast } from "react-toastify";
import { isInformationModeConsumed } from "../hooks";
import { CustomIconsAssociateModal } from "./CustomIconsAssociateModal";

const CountryList = (e: any) => {
    let listPays: any = [];

    if (e.e.selectedRow.Shop !== undefined) {
        listPays =
            e.e.selectedRow.Country.labels !== undefined
                ? e.e.selectedRow.Country.labels
                : [e.e.selectedRow.Country];
    } else {
        listPays =
            e.e.selectedRow.Country.labels !== undefined
                ? e.e.selectedRow.Country.labels
                : e.e.selectedRow.Pays.labels !== undefined
                ? e.e.selectedRow.Pays.labels
                : e.e.selectedRow.Pays !== undefined
                ? e.e.selectedRow.Pays
                : "";
    }

    return (
        <CustomColumnDisplay
            text={`${
                e.e.selectedRow.subRows !== undefined
                    ? Array.isArray(listPays)
                        ? listPays.join(",")
                        : " -- "
                    : listPays
            }`}
        />
    );
};

export const arrayOfCustomColumns = ({
    isArchivedPaymentMethodsClicked,
    isArchivedValidationModalOpened,
    setIsArchivedValidationModalOpened,
    setSelectedRows,
}: {
    isArchivedPaymentMethodsClicked: any;
    isArchivedValidationModalOpened: any;
    setIsArchivedValidationModalOpened: any;
    setSelectedRows: any;
}): customColumnProps[] => [
    {
        indexOFColumn: 1,
        columnName: t("Shop"),
        customJsx: (e: any) => {
            return <span>{e.selectedRow["Shop"]}</span>;
        },
    },
    {
        indexOFColumn: 2,
        columnName: t("Display name"),
        customJsx: (e: any) => {
            return <CustomColumnDisplay text={e.selectedRow["Display name"]} />;
        },
    },
    {
        indexOFColumn: 3,
        columnName: t("Payment method"),
        customJsx: (e: any) => <PaymentMethodRow element={e} />,
        filterName: t("Payment method"),
        canFilter: true,
    },
    {
        indexOFColumn: 4,
        columnName: t("Sales support"),
        customJsx: (e: any) => {
            return (
                <CustomColumnDisplay text={e.selectedRow["Sales support"]} />
            );
        },
    },
    {
        indexOFColumn: 5,
        columnName: t("Address"),
        customJsx: (e: any) => {
            return <CustomColumnDisplay text={e.selectedRow["Address"]} />;
        },
    },
    {
        indexOFColumn: 6,
        columnName: t("Postal code"),
        customJsx: (e: any) => {
            return <CustomColumnDisplay text={e.selectedRow["Postal code"]} />;
        },
    },
    {
        indexOFColumn: 7,
        columnName: t("Country"),
        customJsx: (e: any) => {
            return <CountryList e={e} />;
        },
    },
    {
        indexOFColumn: 9,
        columnName: t("Actions"),
        customJsx: (e: any) => (
            <CustomIcons
                selectedRowData={e}
                isArchivedPaymentMethodsClicked={
                    isArchivedPaymentMethodsClicked
                }
                isArchivedValidationModalOpened={
                    isArchivedValidationModalOpened
                }
                setIsArchivedValidationModalOpened={
                    setIsArchivedValidationModalOpened
                }
                setSelectedRows={setSelectedRows}
            />
        ),
    },
];

export async function handleActivePaymentMethod(
    selectedRowData: any,
    data: any,
    itemsDisable: any,
    fetchGlobal: any
) {
    let dataConfig = {
        userId: data.userID,
        shopId: [selectedRowData.selectedRow.idShop],
        franchiseId: data.franchiseID,
        operatorId: data.operatorID,
        uuidUser: data.uuidUser,
        data: {
            [selectedRowData.selectedRow.id]: {
                designation: selectedRowData.selectedRow[t("Payment method")],
                currency: selectedRowData.selectedRow.Devise,
                display: selectedRowData.selectedRow[t("Display name")],
                shopId: [selectedRowData.selectedRow.idShop],
                saleSupport: selectedRowData.selectedRow[t("Support de vente")],
                country: selectedRowData.selectedRow.Pays,
                tag: selectedRowData.selectedRow.tag,
                isActive: selectedRowData.selectedRow.isActive,
                isArchived: false,
                languages: selectedRowData.selectedRow.languages,
                advancedDisplayName:
                    selectedRowData.selectedRow.advancedDisplayName,
            },
        },
    };
    const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/paymentMethod`;

    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(dataConfig),
    };

    try {
        const result = await fetchGlobal(apiUrl, requestOptions);
        if (result.error) {
            throw Error(result.message);
        }
        if (
            selectedRowData.selectedRow.isActive === false &&
            itemsDisable.find(
                (item: any) =>
                    item.id === selectedRowData.selectedRow.id &&
                    item.shopId === selectedRowData.selectedRow.idShop
            ) === undefined
        ) {
            const item = [
                ...JSON.parse(JSON.stringify(itemsDisable)),
                {
                    id: selectedRowData.selectedRow.id,
                    state: false,
                    shopId: selectedRowData.selectedRow.idShop,
                },
            ];
            setItemsDisable(item);
        }
        ShowSuccessToast(t("The Payment method is successfully activated"));

        setGlobalDataIsUpdated(true);
        setIsLoading(false);
    } catch (error) {
        ErrorToast(`${error}`);
        setIsLoading(false);
    }
}

export async function checkIfSaleSupportIsArchived(
    userID: number,
    franchiseID: string,
    uuidUser: string,
    selectedRows: any,
    i18nextLng: string,
    t: (key: string) => string,
    fetchGlobal: any
): Promise<boolean> {
    toast.dismiss();

    try {
        const rowsArray = Array.isArray(selectedRows)
            ? selectedRows
            : [selectedRows];
        const url = `${process.env.REACT_APP_API_V2_URL}/settings/general/saleSupport?userId=${userID}&franchiseId=${franchiseID}&type=archived&uuidUser=${uuidUser}`;

        const data = await fetchGlobal(url, {
            method: "GET",
            headers: { "Accept-Language": i18nextLng },
        });

        let isSaleSupportArchived = false;

        for (const shopData of data.data) {
            for (const row of rowsArray) {
                const salesSupports = row[t("Sales support")]?.split(",") || [];

                for (const support of salesSupports) {
                    const supportTrimmed = support.trim();
                    const isArchived = shopData.subRows?.some(
                        (sale: any) =>
                            `${sale[t("Sale support")]} ${sale.shopId}` ===
                            `${supportTrimmed} ${row.idShop}`
                    );

                    if (isArchived) {
                        isSaleSupportArchived = true;
                        break;
                    }
                }

                if (isSaleSupportArchived) break;
            }

            if (isSaleSupportArchived) break;
        }

        return isSaleSupportArchived;
    } catch (error: any) {
        setIsLoading(false);
        ErrorToast(error);
        return false;
    }
}

export async function handleStateChange(
    data: boolean,
    info: any,
    selectedRowData: any,
    itemsDisable: any,
    choiceState: any,
    fetchGlobal: any
) {
    setIsLoading(true);
    let dataConfig = {
        userId: info.userID,
        shopId: [selectedRowData.selectedRow.idShop],
        franchiseId: info.franchiseID,
        operatorId: info.operatorID,
        uuidUser: info.uuidUser,
        data: {
            [selectedRowData.selectedRow.id]: {
                designation: selectedRowData.selectedRow[t("Payment method")],
                currency: selectedRowData.selectedRow.Devise,
                display: selectedRowData.selectedRow[t("Display name")],
                shopId: [selectedRowData.selectedRow.idShop],
                saleSupport: selectedRowData.selectedRow[t("Support de vente")],
                country: selectedRowData.selectedRow.Pays,
                tag: selectedRowData.selectedRow.Tag,
                isArchived: selectedRowData.selectedRow.isArchived,
                isActive: data,
                languages: selectedRowData.selectedRow.languages,
                advancedDisplayName:
                    selectedRowData.selectedRow.advancedDisplayName,
            },
        },
    };
    const isStateChange = true;
    const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/paymentMethod`;

    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ dataConfig, isStateChange }),
    };
    try {
        const result = await fetchGlobal(apiUrl, requestOptions);
        if (result.error) {
            throw Error(result.message);
        }
        setIsLoading(false);
        if (
            data === false &&
            itemsDisable.find(
                (item: any) =>
                    item.id === selectedRowData.selectedRow.id &&
                    item.shopId === selectedRowData.selectedRow.idShop
            ) === undefined
        ) {
            const item = [
                ...JSON.parse(JSON.stringify(itemsDisable)),
                {
                    id: selectedRowData.selectedRow.id,
                    state: !choiceState,
                    shopId: selectedRowData.selectedRow.idShop,
                },
            ];
            setItemsDisable(item);
        } else if (data === true) {
            const item = itemsDisable.filter(
                (item: any) =>
                    !(
                        item.id === selectedRowData.selectedRow.id &&
                        item.shopId === selectedRowData.selectedRow.idShop
                    )
            );
            setItemsDisable(item);
        }
        setGlobalDataIsUpdated(true);
        ShowSuccessToast(
            data === true
                ? `${t("Payment method has been successfully activated")}`
                : `${t("Payment method has been successfully deactivated")}`
        );
    } catch (error) {
        setIsLoading(false);
        ErrorToast(`${error}`);
    }
}

export const getArrayOfRows = (selectedRows: any) => {
    let arrayOfRows: any[] = [];

    selectedRows.forEach((el: any) => {
        const exists = (item: any) =>
            arrayOfRows.some(
                (row) => row.id === item.id && row.idShop === item.idShop
            );
        if (
            el[t("Shop")] !== undefined &&
            el.subRows &&
            el.subRows.length > 0
        ) {
            el.subRows.forEach((subRow: any) => {
                if (!exists(subRow) && subRow.id === el.id) {
                    arrayOfRows.push(subRow);
                }
            });
        } else {
            if (!exists(el)) {
                arrayOfRows.push(el);
            }
        }
    });
    return arrayOfRows;
};

export function ArchivedPaymentMethodFranchise(listFranchiseArchived: any) {
    let idsAssociated: any[] = [];
    if (listFranchiseArchived !== undefined) {
        listFranchiseArchived.forEach((element: any) => {
            idsAssociated.push(element.id);
        });
    }

    idsAssociated = [...new Set(idsAssociated)];
    return idsAssociated;
}

export async function handleArchivePaymentMethod(
    itemsDisable: any,
    info: any,
    isActive: boolean,
    selectedRows: any,
    setIsValidateClicked: React.Dispatch<React.SetStateAction<boolean>>,
    fetchGlobal: any
) {
    setIsLoading(true);
    try {
        let shopIds: any = [];
        let data: any = {};
        let isSomeConsumedTrue = false;
        let isSomeConsumedFalse = false;
        let arrayOfRows = getArrayOfRows(selectedRows);
        const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/paymentMethod`;
        let updatedItems = [...itemsDisable];
        for (let el of arrayOfRows) {
            if (!shopIds.includes(el.idShop)) {
                shopIds.push(el.idShop);
            }
        }
        const queryParam = encodeURIComponent(JSON.stringify(shopIds));
        let dataConsumed: any = await isInformationModeConsumed(
            queryParam,
            info.franchiseID,
            fetchGlobal
        );

        for (let el of arrayOfRows) {
            if (el.id !== undefined) {
                let isConsumed =
                    Object.keys(dataConsumed).includes(el.idShop) &&
                    dataConsumed[el.idShop].some(
                        (elt: any) => elt.id === el.id
                    );
                if (isConsumed === true) {
                    isSomeConsumedTrue = true;
                } else {
                    isSomeConsumedFalse = true;
                    if (!data[el.id]) {
                        data[el.id] = {
                            designation: el[t("Payment method")],
                            currency: el.Devise,
                            display: el[t("Display name")],
                            saleSupport: el[t("Support de vente")],
                            shopId: [el.idShop],
                            country: el.Pays,
                            tag: el.Tag,
                            isActive: false,
                            isArchived: isActive,
                            languages: el.languages,
                            advancedDisplayName: el.advancedDisplayName,
                        };
                    } else {
                        const currentShopId = data[el.id].shopId;
                        if (Array.isArray(currentShopId)) {
                            if (!currentShopId.includes(el.idShop)) {
                                currentShopId.push(el.idShop);
                            }
                        } else if (currentShopId !== el.idShop) {
                            data[el.id].shopId = [currentShopId, el.idShop];
                        }
                    }
                    const existingItemIndex = updatedItems.findIndex(
                        (item: any) =>
                            item.id === el.id && item.shopId === el.idShop
                    );

                    if (el.isArchived === false) {
                        if (existingItemIndex > -1) {
                            updatedItems.splice(existingItemIndex, 1);
                        }
                    } else {
                        if (existingItemIndex === -1) {
                            updatedItems = [
                                ...updatedItems,
                                {
                                    id: el.id,
                                    state: false,
                                    shopId: el.idShop,
                                },
                            ];
                        }
                    }
                }
            }
        }
        setItemsDisable(updatedItems);

        if (isSomeConsumedFalse) {
            if (Object.keys(data).length === 0) {
                setIsLoading(false);
                return;
            }
            let objectData = {
                userId: info.userID,
                shopId: shopIds,
                franchiseId: info.franchiseID,
                operatorId: info.operatorID,
                uuidUser: info.uuidUser,
                data,
            };
            try {
                const result = await fetchGlobal(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(objectData),
                });

                if (!result.error) {
                    setIsLoading(false);
                    setGlobalDataIsUpdated(true);
                    setIsValidateClicked(false);
                    ShowSuccessToast(
                        !isActive
                            ? t(
                                  "The Payment method is successfully unarchived"
                              )!
                            : t("The Payment method is successfully archived")!
                    );
                }
            } catch (e) {
                setIsLoading(false);
                ErrorToast(`${e}`);
            }
        }
        if (isSomeConsumedTrue) {
            ErrorToast(
                t(
                    "Please note, you cannot archive an element used in a template"
                )
            );
            setIsLoading(false);
        }
    } catch (error) {
        setIsLoading(false);
        throw error;
    }
}

export const arrayOfCustomColumnsPaymentModalAssociateModal = (
    selectedShopsRows: any,
    selectedPaymentMethod: any
): customColumnProps[] => [
    {
        indexOFColumn: 0,
        columnName: t("Display name"),
        customJsx: (e: any) => (
            <CustomColumnDisplay text={e.selectedRow["Display name"]} />
        ),
    },
    {
        indexOFColumn: 1,
        columnName: t("Payment method"),
        customJsx: (e: any) => (
            <CustomColumnDisplay
                text={e.selectedRow["Type of payment method"]}
            />
        ),
    },
    {
        indexOFColumn: 2,
        columnName: t("Country"),
        customJsx: (e: any) => <ListOfPays e={e} />,
    },
    {
        indexOFColumn: 3,
        columnName: t("Sales support"),
        customJsx: (e: any) => (
            <CustomColumnDisplay text={e.selectedRow["Sales support"]} />
        ),
    },
    {
        indexOFColumn: 6,
        columnName: t("Actions"),
        customJsx: (e: any) => (
            <CustomIconsAssociateModal
                element={e}
                isOneShopClicked={
                    selectedShopsRows.filter(
                        (el: any) => el.subRows !== undefined
                    ).length < 2
                }
                selectedPaymentMethod={selectedPaymentMethod}
            />
        ),
    },
];

const ListOfPays = (e: any) => {
    let listPays: any = [];

    listPays = e.e.selectedRow.Country.labels;
    return (
        <CustomColumnDisplay
            text={`${Array.isArray(listPays) ? listPays.join(",") : " -- "}`}
        />
    );
};

export function CountIds(idsLocalShop: any, selectedRows: any, setIds: any) {
    let number = 0;
    idsLocalShop.forEach((el: any) => {
        selectedRows.forEach((v: any) => {
            if (v.Id === el) {
                number = number + 1;
            }
        });
    });
    setIds(number);
}

export function checkIfPaymentMethodExistAndArchived(shopsSelectedRow: any) {
    let archived: any[] = [];
    if (shopsSelectedRow.length > 0) {
        shopsSelectedRow.forEach((element: any) => {
            if (element?.archivedPaymentMethods !== undefined) {
                element?.archivedPaymentMethods.forEach((el: any) => {
                    archived.push(el.id);
                });
            }
        });
    }
    return archived;
}

export function shouldDisableAction(
    isLoading: boolean,
    selectedRows: any[],
    isArchivedPaymentMethodsClicked: boolean,
    listFranchiseArchived: any
): boolean {
    const rows = getArrayOfRows(selectedRows);

    return (
        isLoading ||
        selectedRows.length === 0 ||
        (isArchivedPaymentMethodsClicked &&
            rows.some((element: any) =>
                ArchivedPaymentMethodFranchise(listFranchiseArchived).includes(
                    element.id
                )
            )) ||
        rows.length === 0
    );
}

// ============== TYPES ==============
interface PaymentMethodConfig {
    info: UserInfo;
    activePaymentMethods: PaymentMethod[];
    salesSupports: SalesSupport[];
    selectedRows: SelectedRow[];
    selectedShopsRows: ShopRow[];
    shopsSelectedRow: ShopRow[];
    itemsDisable: DisabledItem[];
}

interface UserInfo {
    userID: string;
    franchiseID: string;
    operatorID: string;
    uuidUser: string;
}

interface PaymentMethod {
    id: string;
    state: boolean;
}

interface SalesSupport {
    id: string;
    salesSupport: string[];
}

interface SelectedRow {
    id: string;
    Pays: { labels: string[] };
    Devise: string;
    Tag: string;
    isArchived: boolean;
    languages: any;
    advancedDisplayName: any;
    [key: string]: any;
}

interface ShopRow {
    idShop: string;
    Pays: string;
    subRows?: SelectedRow[];
    archivedPaymentMethods?: { idShop: string; id: string }[];
}

interface DisabledItem {
    id: string;
    state: boolean;
    shopId: string;
}

interface ProcessedData {
    data: Record<string, any>;
    shopIds: string[];
    itemsDisable: DisabledItem[];
    isReassignment: boolean[];
    salesSupportInShops: boolean[];
}

const checkSalesSupportInShop = (
    salesSupportString: string,
    shopId: string,
    salesSupports: SalesSupport[]
): boolean => {
    const FUNC_NAME = "checkSalesSupportInShop";
    try {
        const shop = salesSupports.find((s) => s.id === shopId);
        return (salesSupportString ?? "")
            .split(",")
            .some((elm) => shop?.salesSupport?.includes(elm) ?? false);
    } catch (error) {
        console.error(`[${FUNC_NAME}] Error:`, error);
        return false;
    }
};

const filterSalesSupport = (
    salesSupportString: string,
    shopId: string,
    salesSupports: SalesSupport[]
): string => {
    const FUNC_NAME = "filterSalesSupport";
    try {
        const shop = salesSupports.find((s) => s.id === shopId);
        if (!shop?.salesSupport) return "";

        return (salesSupportString ?? "")
            .split(",")
            .filter((value) => shop.salesSupport.includes(value))
            .join(",");
    } catch (error) {
        console.error(`[${FUNC_NAME}] Error:`, error);
        return "";
    }
};

const findIndexInAssociated = (
    subRows: SelectedRow[] | undefined,
    rowId: string
): number => {
    const FUNC_NAME = "findIndexInAssociated";
    try {
        return subRows?.findIndex((item) => item.id === rowId) ?? -1;
    } catch (error) {
        console.error(`[${FUNC_NAME}] Error:`, error);
        return -1;
    }
};

const checkIsLocalAssociated = (
    shop: ShopRow,
    row: SelectedRow,
    index: number,
    activePaymentMethods: PaymentMethod[]
): boolean => {
    const FUNC_NAME = "checkIsLocalAssociated";
    try {
        if (!shop.subRows?.length || index < 0 || !shop.subRows[index])
            return false;

        const activeMethod = activePaymentMethods.find((m) => m.id === row.id);
        if (!activeMethod) return false;

        return shop.subRows[index].isActive !== activeMethod.state;
    } catch (error) {
        console.error(`[${FUNC_NAME}] Error:`, error);
        return false;
    }
};

const checkDisplayNameChanged = (
    shop: ShopRow,
    row: SelectedRow,
    index: number
): boolean => {
    const FUNC_NAME = "checkDisplayNameChanged";
    try {
        const subRow = shop.subRows?.[index];
        return subRow
            ? subRow[t("Display name")] !== row[t("Display name")]
            : false;
    } catch (error) {
        console.error(`[${FUNC_NAME}] Error:`, error);
        return false;
    }
};

const getShopsSalesSupport = (
    shopsSelectedRow: ShopRow[],
    shop: ShopRow,
    row: SelectedRow
): string[] => {
    const FUNC_NAME = "getShopsSalesSupport";
    try {
        for (const selectedShop of shopsSelectedRow) {
            if (selectedShop.idShop !== shop.idShop || !shop.subRows) continue;

            const matchingSubRow = shop.subRows.find((e) => e.id === row.id);
            if (matchingSubRow) {
                return (matchingSubRow[t("Sales support")] ?? "").split(",");
            }
        }
        return [];
    } catch (error) {
        console.error(`[${FUNC_NAME}] Error:`, error);
        return [];
    }
};

const checkSalesSupportMatch = (
    rowSalesSupport: string,
    shopsSalesSupport: string[]
): boolean => {
    const FUNC_NAME = "checkSalesSupportMatch";
    try {
        const rowSupports = (rowSalesSupport ?? "").split(",");
        return (
            rowSupports.length === shopsSalesSupport.length &&
            rowSupports.every(
                (value, index) => value === shopsSalesSupport[index]
            )
        );
    } catch (error) {
        console.error(`[${FUNC_NAME}] Error:`, error);
        return false;
    }
};

const shouldAssociate = (
    row: SelectedRow,
    shop: ShopRow,
    salesSupportInShop: boolean,
    index: number,
    isLocalAssociated: boolean,
    displayNameChanged: boolean,
    isSalesSupportMatch: boolean
): boolean => {
    const FUNC_NAME = "shouldAssociate";
    try {
        const countryMatch = row.Pays?.labels?.includes(shop.Pays) ?? false;
        if (!countryMatch || !salesSupportInShop) return false;

        return (
            index === -1 ||
            isLocalAssociated ||
            displayNameChanged ||
            !isSalesSupportMatch
        );
    } catch (error) {
        console.error(`[${FUNC_NAME}] Error:`, error);
        return false;
    }
};

const updateItemsDisable = (
    itemsDisable: DisabledItem[],
    row: SelectedRow,
    shopId: string,
    activePaymentMethods: PaymentMethod[]
): DisabledItem[] => {
    const FUNC_NAME = "updateItemsDisable";
    try {
        const isInactive =
            activePaymentMethods.find((m) => m.id === row.id)?.state === false;

        if (isInactive) {
            const exists = itemsDisable.some(
                (item) => item.id === row.id && item.shopId === shopId
            );
            if (!exists) {
                return [...itemsDisable, { id: row.id, state: false, shopId }];
            }
        } else {
            return itemsDisable.filter(
                (item) => !(item.id === row.id && item.shopId === shopId)
            );
        }

        return itemsDisable;
    } catch (error) {
        console.error(`[${FUNC_NAME}] Error:`, error);
        return itemsDisable;
    }
};

const buildPaymentMethodData = (
    row: SelectedRow,
    shopId: string,
    filteredSalesSupport: string,
    activePaymentMethods: PaymentMethod[],
    existingData: Record<string, any>
): Record<string, any> => {
    const FUNC_NAME = "buildPaymentMethodData";
    try {
        const data = { ...existingData };

        if (!data[row.id]) {
            data[row.id] = {
                designation: row[t("Type of payment method")],
                currency: row.Devise,
                display: row[t("Display name")],
                shopId: [shopId],
                saleSupport: filteredSalesSupport,
                country: row.Pays,
                tag: row.Tag,
                isActive: activePaymentMethods.find((m) => m.id === row.id)
                    ?.state,
                isArchived: row.isArchived,
                languages: row.languages,
                advancedDisplayName: row.advancedDisplayName,
            };
        } else {
            const currentShopIds = data[row.id].shopId;
            if (Array.isArray(currentShopIds)) {
                if (!currentShopIds.includes(shopId)) {
                    currentShopIds.push(shopId);
                }
            } else if (currentShopIds !== shopId) {
                data[row.id].shopId = [currentShopIds, shopId];
            }
        }

        return data;
    } catch (error) {
        console.error(`[${FUNC_NAME}] Error:`, error);
        return existingData;
    }
};

// ============== PROCESS FUNCTIONS ==============

const processShopAndRow = (
    shop: ShopRow,
    row: SelectedRow,
    config: PaymentMethodConfig,
    currentData: ProcessedData
): ProcessedData => {
    const FUNC_NAME = "processShopAndRow";
    try {
        const {
            activePaymentMethods,
            salesSupports,
            shopsSelectedRow,
        } = config;
        let {
            data,
            shopIds,
            itemsDisable,
            isReassignment,
            salesSupportInShops,
        } = currentData;

        const index = findIndexInAssociated(shop.subRows, row.id);
        const salesSupportInShop = checkSalesSupportInShop(
            row["Sales support"],
            shop.idShop,
            salesSupports
        );

        salesSupportInShops.push(salesSupportInShop);

        const isLocalAssociated = checkIsLocalAssociated(
            shop,
            row,
            index,
            activePaymentMethods
        );
        const displayNameChanged = checkDisplayNameChanged(shop, row, index);
        const shopsSalesSupport = getShopsSalesSupport(
            shopsSelectedRow,
            shop,
            row
        );
        const isSalesSupportMatch = checkSalesSupportMatch(
            row["Sales support"],
            shopsSalesSupport
        );

        isReassignment.push(isLocalAssociated);

        if (
            shouldAssociate(
                row,
                shop,
                salesSupportInShop,
                index,
                isLocalAssociated,
                displayNameChanged,
                isSalesSupportMatch
            )
        ) {
            itemsDisable = updateItemsDisable(
                itemsDisable,
                row,
                shop.idShop,
                activePaymentMethods
            );

            const filteredSalesSupport = filterSalesSupport(
                row[t("Sales support")],
                shop.idShop,
                salesSupports
            );

            data = buildPaymentMethodData(
                row,
                shop.idShop,
                filteredSalesSupport,
                activePaymentMethods,
                data
            );

            if (!shopIds.includes(shop.idShop)) {
                shopIds.push(shop.idShop);
            }
        }

        return {
            data,
            shopIds,
            itemsDisable,
            isReassignment,
            salesSupportInShops,
        };
    } catch (error) {
        console.error(`[${FUNC_NAME}] Error:`, error);
        return currentData;
    }
};

const processAllShopsAndRows = (config: PaymentMethodConfig): ProcessedData => {
    const FUNC_NAME = "processAllShopsAndRows";
    try {
        let result: ProcessedData = {
            data: {},
            shopIds: [],
            itemsDisable: [...config.itemsDisable],
            isReassignment: [],
            salesSupportInShops: [],
        };

        for (const shop of config.selectedShopsRows) {
            for (const row of config.selectedRows) {
                result = processShopAndRow(shop, row, config, result);
            }
        }

        return result;
    } catch (error) {
        console.error(`[${FUNC_NAME}] Error:`, error);
        return {
            data: {},
            shopIds: [],
            itemsDisable: [...config.itemsDisable],
            isReassignment: [],
            salesSupportInShops: [],
        };
    }
};

// ============== TOAST HANDLERS ==============

const showResultToasts = (
    salesSupportInShops: boolean[],
    isReassignment: boolean[],
    itemsDisable: DisabledItem[]
): void => {
    const FUNC_NAME = "showResultToasts";
    try {
        const hasSuccess = salesSupportInShops.includes(true);
        const hasFailure = salesSupportInShops.includes(false);
        const isReassign = isReassignment.includes(true);

        const warningConfig = {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
            theme: "colored" as const,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
        };

        if (!hasSuccess) {
            toast.warn(
                t(
                    "Please note that the assignment could not be made to one or more stores. Please check the store(s) data settings."
                ),
                warningConfig
            );
            return;
        }

        setItemsDisable(itemsDisable);
        ShowSuccessToast(
            t(
                isReassign
                    ? "The reassignment was successful"
                    : "The assignment was successful"
            )
        );

        if (hasFailure) {
            toast.warn(
                t(
                    "Please note that the assignment could not be made to one or more stores. Please check the store(s) data settings."
                ),
                warningConfig
            );
        }
    } catch (error) {
        console.error(`[${FUNC_NAME}] Error:`, error);
    }
};

// ============== API HANDLER ==============

const submitPaymentMethods = async (
    processedData: ProcessedData,
    info: UserInfo,
    fetchGlobal: any
): Promise<boolean> => {
    const FUNC_NAME = "submitPaymentMethods";
    try {
        const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/paymentMethod`;

        const payload = {
            userId: info.userID,
            shopId: processedData.shopIds,
            franchiseId: info.franchiseID,
            operatorId: info.operatorID,
            uuidUser: info.uuidUser,
            data: processedData.data,
            isAssociate: !processedData.isReassignment.includes(true),
            isReassignment: processedData.isReassignment.includes(true),
        };

        const response = await fetchGlobal(apiUrl, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
        });

        if (response.error) {
            throw new Error("API Error");
        }

        return true;
    } catch (error) {
        console.error(`[${FUNC_NAME}] Error:`, error);
        throw error;
    }
};

// ============== RESET STATE HANDLER ==============

const resetState = (
    setIsLoading: (v: boolean) => void,
    setIsValidateClicked: (v: boolean) => void,
    setIsAssociateModalOpened: (v: boolean) => void,
    isAssociateModalOpened: boolean,
    setSelectedRows: (v: any[]) => void,
    setIsValidateButtonDisabled: (v: boolean) => void
): void => {
    const FUNC_NAME = "resetState";
    try {
        setIsLoading(false);
        setIsValidateClicked(false);
        setIsAssociateModalOpened(!isAssociateModalOpened);
        setGlobalDataIsUpdated(true);
        setSelectedRows([]);
        setIsValidateButtonDisabled(false);
    } catch (error) {
        console.error(`[${FUNC_NAME}] Error:`, error);
    }
};

// ============== MAIN FUNCTION ==============

export async function handleAssociatePaymentMethodsButtonClick(
    info: any,
    isAssociateModalOpened: boolean,
    setIsAssociateModalOpened: any,
    setIsValidateClicked: any,
    setSelectedRows: (v: any[]) => void,
    activePaymentMethods: PaymentMethod[],
    salesSupports: SalesSupport[],
    selectedRows: SelectedRow[],
    selectedShopsRows: ShopRow[],
    itemsDisable: DisabledItem[],
    shopsSelectedRow: ShopRow[],
    isValidateButtonDisabled: boolean,
    setIsValidateButtonDisabled: any,
    fetchGlobal: any
): Promise<void> {
    const FUNC_NAME = "handleAssociatePaymentMethodsButtonClick";

    try {
        // Early return validations
        if (isValidateButtonDisabled) {
            console.warn(`[${FUNC_NAME}] Button is disabled, skipping`);
            return;
        }

        if (!selectedRows?.length) {
            console.warn(`[${FUNC_NAME}] No rows selected, skipping`);
            return;
        }

        // Initialize loading state
        setIsLoading(true);
        setIsValidateButtonDisabled(true);

        const config: PaymentMethodConfig = {
            info,
            activePaymentMethods,
            salesSupports,
            selectedRows,
            selectedShopsRows,
            shopsSelectedRow,
            itemsDisable,
        };

        // Process all data
        const processedData = processAllShopsAndRows(config);
        // Early return if no data to process
        if (Object.keys(processedData.data).length === 0) {
            ErrorToast(
                t(
                    `You can’t assign a payment method in the shop. Thanks for verifying the shops’ sales support.`
                )
            );
            setIsLoading(false);
            setIsAssociateModalOpened(!isAssociateModalOpened);
            setIsValidateButtonDisabled(false);
            return;
        }

        // Submit to API
        await submitPaymentMethods(processedData, info, fetchGlobal);

        // Show appropriate toasts
        showResultToasts(
            processedData.salesSupportInShops,
            processedData.isReassignment,
            processedData.itemsDisable
        );

        // Reset all state
        resetState(
            setIsLoading,
            setIsValidateClicked,
            setIsAssociateModalOpened,
            isAssociateModalOpened,
            setSelectedRows,
            setIsValidateButtonDisabled
        );
    } catch (error) {
        console.error(`[${FUNC_NAME}] Error:`, error);
        ErrorToast(`${error}`);
        setIsLoading(false);
        setIsValidateButtonDisabled(false);
    }
}
